"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MuiPickersTzUtilsProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pickers = require("@material-ui/pickers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MuiPickersTzUtilsProvider = exports.MuiPickersTzUtilsProvider = function MuiPickersTzUtilsProvider(_ref) {
  var children = _ref.children,
    utils = _ref.utils,
    dateFormats = _ref.dateFormats,
    dateLibInstance = _ref.dateLibInstance,
    locale = _ref.locale,
    timeZone = _ref.timeZone;
  var utilsContext = (0, _react.useMemo)(function () {
    return new utils({
      locale: locale,
      timeZone: timeZone,
      formats: dateFormats,
      instance: dateLibInstance
    });
  }, [utils, locale, timeZone, dateFormats, dateLibInstance]);
  return /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersContext.Provider, {
    value: utilsContext,
    children: children
  });
};
MuiPickersTzUtilsProvider.propTypes = {
  utils: _propTypes["default"].func.isRequired,
  locale: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  timeZone: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].element.isRequired, _propTypes["default"].arrayOf(_propTypes["default"].element.isRequired)]).isRequired
};
var _default = exports["default"] = MuiPickersTzUtilsProvider;